import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { PrebidModuleType } from 'features/globalSetup/types/prebidModule'
import { generateSelector } from 'providers/product-fruits/utils'
import { AnalyticsAdaptersList } from '../../AnalyticsAdapters/AnalyticsAdaptersList'
import { GeneralList } from '../../Gneral/GeneralList'
import { UserIdsList } from '../../UserIds/UserIdsList'
import { VendorSpecificList } from '../../VendorSpecific/VendorSpecificList'

export const useTabs = (): Tab<PrebidModuleType>[] => {
  const { t } = useTranslation('features/globalSetup')

  return [
    {
      element: 'general',
      label: t('prebid.modules.tab.general'),
      page: <GeneralList />,
      productFruitsSelector: generateSelector({ step: 2, tour: 4 }),
    },
    {
      element: 'userId',
      label: t('prebid.modules.tab.userIds'),
      page: <UserIdsList />,
    },
    {
      element: 'vendorSpecific',
      label: t('prebid.modules.tab.vendorSpecific'),
      page: <VendorSpecificList />,
    },
    {
      element: 'analytics',
      label: t('prebid.modules.tab.analytics'),
      page: <AnalyticsAdaptersList />,
    },
  ]
}
